module.exports = __webpack_public_path__ + "img/4.f189aa5e.jpg";